import {Link, Typography} from '@mui/material';
import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

const HelpContent = () => {
  const {t} = useTranslation();

  return (
    <section>
      <Typography variant="subtitle2">
        {t('uploadDialog.helpTypesTitle')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t('uploadDialog.helpTypesMessage')}
      </Typography>

      <Typography variant="subtitle2">
        {t('uploadDialog.helpGeojsonTitle')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        <Trans
          i18nKey="uploadDialog.helpGeojsonMessage"
          components={{
            helpLink: (
              <Link
                underline="always"
                color="textPrimary"
                href="https://tools.ietf.org/html/rfc7946"
                target="_blank"
                rel="noreferrer noopener"
              />
            ),
          }}
        />
      </Typography>

      <Typography variant="subtitle2">
        {t('uploadDialog.helpPrjTitle')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t('uploadDialog.helpPrjMessage')}
      </Typography>

      <Typography variant="subtitle2">
        {t('uploadDialog.helpZipTitle')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t('uploadDialog.helpZipMessage')}
      </Typography>

      <Typography variant="subtitle2">
        {t('uploadDialog.helpCountTitle')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t('uploadDialog.helpCountMessage')}
      </Typography>
    </section>
  );
};

export default HelpContent;
